import Enums from 'utils/EnumsManager';

const { Leads } = Enums.ObjectTypes;

class BaseReport {
  constructor(params) {
    // validations
    if (!_.isPlainObject(params)) {
      return console.error(
        'TypeError: "params" should be a object for Report!'
      );
    }

    const { id = -1, name = '', type = Leads } = params;

    this.id = id;
    this.name = name;
    this.type = type;
  }
}

export default BaseReport;



// WEBPACK FOOTER //
// ./src/models/Reports/BaseReport.js